import { Link } from "react-router-dom";
import { Instagram } from "lucide-react";
export default function Footer() {
  return (
    <footer data-testid="site-footer" className="relative border-t border-white/5 bg-transparent">
      <div className="mx-auto max-w-7xl px-5 py-16 lg:px-8">
        <div className="flex flex-col justify-between gap-12 md:flex-row">
          <div className="max-w-sm">
            <Link to="/" className="flex items-center gap-2.5">
              <img
                src="/logo.png"
                alt="FestivalPlan Logo"
                className="h-10 w-10 rounded-xl object-cover"
              />
              <span className="font-display text-lg font-semibold text-white">FestivalPlan</span>
            </Link>
            <p className="mt-4 text-sm leading-relaxed text-white/50">
              Eine App für die gesamte Festivalcrew. Von der Packliste bis zur Gruppenkasse –
              alles an einem Ort.
            </p>
          </div>

          <div className="grid grid-cols-2 gap-10 sm:grid-cols-3">
            <FooterCol title="Rechtliches" links={[
              { label: "Datenschutz", to: "/datenschutz" },
              { label: "Impressum", to: "/impressum" },
              { label: "AGB", to: "/agb" },
              { label: "Nutzungsbedingungen", to: "/nutzungsbedingungen" },
              { label: "Konto löschen", to: "/konto-loeschen" },
            ]} />
            <FooterCol title="Produkt" links={[
              { label: "Features", to: "/features" },
              { label: "Download", to: "/download" },
              { label: "FAQ", to: "/faq" },
              { label: "Über uns", to: "/ueber-uns" },
              { label: "Support", to: "/support" },
            ]} />
            <div>
              <h4 className="mb-4 text-xs uppercase tracking-[0.2em] text-white/40">Social</h4>
              <div className="flex gap-3">
                {[
                  { Icon: Instagram, label: "Instagram", href: "https://www.instagram.com/festivalplan.app?igsh=dnY4cjQxYzJsbHpw&utm_source=qr" },
                ].map(({ Icon, label, href }) => (
                  <a
                    key={label}
                    href={href}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={label}
                    data-testid={`social-${label.toLowerCase()}`}
                    className="grid h-10 w-10 place-items-center rounded-full border border-white/10 text-white/60 transition-colors hover:border-[#00E5FF]/50 hover:text-white"
                  >
                    <Icon className="h-4 w-4" />
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>

        <div className="mt-14 flex flex-col items-center justify-between gap-3 border-t border-white/5 pt-8 text-sm text-white/40 sm:flex-row">
          <p>© 2026 FestivalPlan</p>
          <p>Made for the crew. 🎪</p>
        </div>
      </div>
    </footer>
  );
}

function FooterCol({ title, links }) {
  return (
    <div>
      <h4 className="mb-4 text-xs uppercase tracking-[0.2em] text-white/40">{title}</h4>
      <ul className="space-y-3">
        {links.map((l) => (
          <li key={l.label}>
            {l.to ? (
              <Link to={l.to} className="text-sm text-white/60 transition-colors hover:text-white">
                {l.label}
              </Link>
            ) : (
              <a href={l.href} className="text-sm text-white/60 transition-colors hover:text-white">
                {l.label}
              </a>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
}
